import { LegalPage, Section } from "./legal.privacy";

export function meta() {
  return [{ title: "Company Details — Orchestrate" }];
}

export default function CompanyDetails() {
  return (
    <LegalPage title="Company Details">
      <Section title="About APTIM-Solutions">
        <p>
          Orchestrate is developed and operated by APTIM-Solutions Ltd, a programme and project
          management consultancy specialising in structured delivery, digital transformation, and
          the APTIM-Solutions Input Management Framework.
        </p>
      </Section>

      <Section title="Company Information">
        <table className="w-full text-sm border-collapse [&_td]:py-2 [&_td]:pr-4 [&_td:first-child]:font-semibold [&_td:first-child]:text-navy [&_td:first-child]:w-48 [&_tr]:border-b [&_tr]:border-border-light">
          <tbody>
            <tr>
              <td>Registered Name</td>
              <td>APTIM-Solutions Ltd</td>
            </tr>
            <tr>
              <td>Jurisdiction</td>
              <td>England and Wales</td>
            </tr>
            <tr>
              <td>Nature of Business</td>
              <td>Programme & Project Management Consultancy, Software Development</td>
            </tr>
            <tr>
              <td>Product</td>
              <td>Orchestrate — Programme & Project Governance Platform</td>
            </tr>
          </tbody>
        </table>
      </Section>

      <Section title="Contact Information">
        <table className="w-full text-sm border-collapse [&_td]:py-2 [&_td]:pr-4 [&_td:first-child]:font-semibold [&_td:first-child]:text-navy [&_td:first-child]:w-48 [&_tr]:border-b [&_tr]:border-border-light">
          <tbody>
            <tr>
              <td>General Enquiries</td>
              <td>
                <a
                  href="mailto:info@aptim-solutions.com"
                  className="text-accent-brand hover:underline"
                >
                  info@aptim-solutions.com
                </a>
              </td>
            </tr>
            <tr>
              <td>Privacy & Data</td>
              <td>
                <a
                  href="mailto:privacy@aptim-solutions.com"
                  className="text-accent-brand hover:underline"
                >
                  privacy@aptim-solutions.com
                </a>
              </td>
            </tr>
            <tr>
              <td>Legal</td>
              <td>
                <a
                  href="mailto:legal@aptim-solutions.com"
                  className="text-accent-brand hover:underline"
                >
                  legal@aptim-solutions.com
                </a>
              </td>
            </tr>
            <tr>
              <td>Support</td>
              <td>
                <a
                  href="mailto:support@aptim-solutions.com"
                  className="text-accent-brand hover:underline"
                >
                  support@aptim-solutions.com
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </Section>

      <Section title="Regulatory Information">
        <p>
          APTIM-Solutions Ltd is committed to compliance with UK and EU data protection legislation,
          including the UK GDPR, EU GDPR, and the Data Protection Act 2018.
        </p>
        <p>
          The supervisory authority for data protection in the United Kingdom is the Information
          Commissioner&apos;s Office (ICO):{" "}
          <a
            href="https://ico.org.uk"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent-brand hover:underline"
          >
            ico.org.uk
          </a>
        </p>
      </Section>

      <Section title="Hosting & Infrastructure">
        <p>
          Orchestrate is hosted on infrastructure within the EU region, ensuring compliance with
          data residency requirements for UK and EU clients. Our hosting and infrastructure partners
          include:
        </p>
        <ul>
          <li>
            <strong>Application hosting:</strong> Fly.io (EU region)
          </li>
          <li>
            <strong>Database:</strong> PostgreSQL (EU region)
          </li>
          <li>
            <strong>Authentication:</strong> Auth0 by Okta
          </li>
          <li>
            <strong>Email delivery:</strong> Resend
          </li>
          <li>
            <strong>AI services:</strong> Anthropic (Claude API)
          </li>
          <li>
            <strong>Analytics:</strong> Microsoft Clarity (anonymised)
          </li>
          <li>
            <strong>Error monitoring:</strong> Sentry
          </li>
        </ul>
      </Section>
    </LegalPage>
  );
}
